import type { IconData } from '@stacksjs/iconify-core'

export const cz1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v256H0z\"/><path fill=\"#d7141a\" d=\"M0 256h512v256H0z\"/><path fill=\"#11457e\" d=\"M300 256L0 56v400z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cz1x1
